
const AudioMapData = cc.Class({
    name: 'AudioMapData',
    properties: {
        clip: cc.AudioClip,
        isAudioSprite: false,
        spriteName: '',
        volume: {
            default: 1,
            type: cc.Float,
            range: [0, 1, 0.1],
            slide: true
        },

    },
});

export default AudioMapData;
